import {ComponentType} from 'react';

import dynamic, {Loader} from 'next/dynamic';

import {LoaderPageMb} from '@/ui/pages/mb/LoaderPageMb/LoaderPageMb';
import {LoaderPageWeb} from '@/ui/pages/web/LoaderPageWeb/LoaderPageWeb';

// lazy-components
const WebRoutes = getDynamicComponent(() => import('@/routes/WebRoutes/WebRoutes'), <LoaderPageWeb />);
const MbRoutes = getDynamicComponent(() => import('@/routes/MbRoutes/MbRoutes'), <LoaderPageMb />);

function getDynamicComponent(loader: Loader, loadingComponent: JSX.Element): ComponentType {
  return dynamic({
    loader,
    loading: () => loadingComponent,
    ssr: false,
  });
}

export const routes = {
  web: <WebRoutes />,
  mb: <MbRoutes />,
} as const;
